export const GRAPHQL_ENDPOINT: string = process.env.REACT_APP_API_END_POINT as string;
export const API_ENDPOINT: string = process.env.REACT_APP_REST_API_END_POINT as string;
export const FRONTEND_URL: string = process.env.REACT_APP_FRONTEND_URL as string;
export const S3_BASE_URL: string = process.env.REACT_APP_S3_BASE_URL as string;

/** Base URL for guest ordering (QR codes). Configurable via REACT_APP_GUEST_ORDER_BASE_URL. */
export const GUEST_ORDER_BASE_URL: string =
  (process.env.REACT_APP_GUEST_ORDER_BASE_URL as string) || "https://www.eatsbits.com";
